import classNames from "classnames";
import Link from "rivals/components/shared/Link";
import EmbedProspectCard from "rivals/components/shared/Prospect/EmbedProspectCard";
import ProspectCard from "rivals/components/shared/Prospect/ProspectCard";
import {
  AthleteBioVariants,
  AthleteViews
} from "rivals/shared/interfaces/Athlete";
import styles from "./AthleteCard.module.scss";
import CollegePlayerCard from "./CollegePlayerCard";
import SocialHeader from "./SocialHeader";
import strings from "./strings";
import { Props } from "./types";

const { philter } = strings;

function AthleteCard({
  collegePlayer,
  embed,
  isSocialMediaCard = false,
  prospect,
  view
}: Props): JSX.Element | null {
  let card: JSX.Element;
  let url = "";

  if (view === AthleteViews.PROSPECT_VIEW && prospect) {
    card = embed ? (
      <EmbedProspectCard prospect={prospect} />
    ) : (
      <ProspectCard prospect={prospect} />
    );
    url = `${prospect.athleteUrl}?view=pv`;
  } else if (view === AthleteViews.COLLEGE_PLAYER_VIEW && collegePlayer) {
    card = (
      <CollegePlayerCard
        bioVariant={
          isSocialMediaCard
            ? AthleteBioVariants.SOCIAL_CARD
            : AthleteBioVariants.CARD
        }
        collegePlayer={collegePlayer}
        data={philter.replace("[type]", "athlete")}
      />
    );
    url = `${collegePlayer.athleteUrl}?view=cv`;
  } else {
    return null;
  }

  const containerClasses = classNames(styles.container, {
    [styles.socialMediaCard]: isSocialMediaCard
  });

  return (
    <Link className={containerClasses} href={url} target="_parent">
      {isSocialMediaCard && view === AthleteViews.COLLEGE_PLAYER_VIEW && (
        <SocialHeader
          isCollegePlayer={view === AthleteViews.COLLEGE_PLAYER_VIEW}
        />
      )}
      {card}
    </Link>
  );
}

export default AthleteCard;
